/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(function () {

    $(function () {


        $("body").on("click", ".enquire-button-action", function () {
            // Create the form popup HTML
            var form = '<div class="form-wrapper" style="opacity:0;"><div class="iframe-wrapper" style="transform: translateX(100%); transition: transform 0.3s ease-in-out;"><iframe src="https://form.typeform.com/to/qclQmXth?typeform-embed-id=045219610318227854&amp;typeform-embed=popup-drawer&amp;typeform-source=southboundbikes.com&amp;typeform-medium=snippet&amp;typeform-medium-version=next&amp;typeform-embed-handles-redirect=1" data-testid="iframe" allow="microphone; camera" title="Oryx Lead Form" style="border: 0px; transform: translateZ(0px);"></iframe><button class="close_form" aria-label="Close">×</button></div></div>';

            // Append the form to the body
            $("body").append(form);

            // Trigger reflow to ensure the transitions will work
            $(".form-wrapper")[0].offsetHeight;

            // Show the form with animation
            $(".form-wrapper").css("opacity", 1);
            $(".iframe-wrapper").css("transform", 'translateX(0)');

            return false;
        });


        $("body").on("click", ".preorder-button-action", function () {

            $("html, body").css("overflow", 'hidden');
            $("body").addClass('form-open');

            // Trigger reflow to ensure the transitions will work
            $(".form-wrapper,product-enquiry")[0].offsetHeight;

            // Show the form with animation
            $(".form-wrapper.product-enquiry").css("opacity", 1);
            $(".form-wrapper.product-enquiry").css("visibility", 'visible');
            $(".iframe-wrapper").css("transform", 'translateX(0)');

            return false;
        });

        $("body").on("click", ".notify-button-action", function () {

            $("html, body").css("overflow", 'hidden');
            $("body").addClass('form-open');

            // Trigger reflow to ensure the transitions will work
            $(".form-wrapper,notify-enquiry")[0].offsetHeight;

            // Show the form with animation
            $(".form-wrapper.notify-enquiry").css("opacity", 1);
            $(".form-wrapper.notify-enquiry").css("visibility", 'visible');
            $(".iframe-wrapper").css("transform", 'translateX(0)');

            return false;
        });

        $("body").on("click", ".claims-button", function () {
            // Create the form popup HTML
            var form = '<div class="form-wrapper" style="opacity:0;"><div class="iframe-wrapper" style="transform: translateX(100%); transition: transform 0.3s ease-in-out;"><iframe src="https://form.typeform.com/to/jDqPrbxM?typeform-embed-id=5391472763207799&typeform-embed=popup-drawer&typeform-source=southboundbikes.com&typeform-medium=snippet&typeform-medium-version=next&typeform-embed-handles-redirect=1&typeform-embed-no-heading=true" data-testid="iframe" allow="microphone; camera" title="Claims Form" style="border: 0px; transform: translateZ(0px);"></iframe><button class="close_form" aria-label="Close">×</button></div></div>';

            // Append the form to the body
            $("body").append(form);

            // Trigger reflow to ensure the transitions will work
            $(".form-wrapper")[0].offsetHeight;

            // Show the form with animation
            $(".form-wrapper").css("opacity", 1);
            $(".iframe-wrapper").css("transform", 'translateX(0)');

            return false;
        });

        // Event to close the form
        $("body").on("click", ".close_form", function () {

            $("html, body").css("overflow", 'auto');
            $("body").removeClass('form-open');

            // Reverse animation
            $(".iframe-wrapper").css("transform", 'translateX(100%)');
            $(".form-wrapper").css("opacity", 0);
            $(".form-wrapper").css("visibility", 'hidden');

            // Remove the form after animation completes
            if (!$('.form-wrapper').hasClass('product-enquiry') && !$('.form-wrapper').hasClass('notify-enquiry')) {

                setTimeout(function () {
                    $(".form-wrapper").remove();
                }, 300); // Match this duration with your transition time

            }

            return false;
        });

        /*
        $('.preorder-enquiry-form').on('submit', function (e) {
            e.preventDefault();

            var $form = $(this);
            var formData = new FormData(this);

            $.ajax({
                url: '/contact',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function () {
                    $form[0].reset();
                    $('#enquiry-success').show();
                    $('#enquiry-error').hide();
                },
                error: function (data) {

                    console.error('Error submitting form:', data);

                    $('#enquiry-success').hide();
                    $('#enquiry-error').show();

                }
            });
        });
        */

    });


});
